module.exports = __webpack_public_path__ + "img/tour-56.02f8a66b.png";